import { useCallback } from 'react';
import { FileBrowserProvider, ROOT } from 'app/domains/filesystem';
import { EntryKind } from 'shared/domains/apollo/generated/types';
import { useEntries } from './useEntries';
import { FileDialog } from '../FileDialog';
/**
 * Generic entry picker dialog with multiselect support.
 * Will default to only selecting documents.
 * @param props
 * @returns
 */
export function EntryPickerDialog(props) {
    const { selfId, initialFolderId = ROOT, includeDocumentAi = false, initialEntryIds, multiselect, onSubmit, selectable, } = props;
    const { entries, setEntries, loading } = useEntries({ initialEntryIds });
    const handleSelectEntry = useCallback((entry) => {
        if (!multiselect) {
            setEntries([entry]);
        }
        else {
            setEntries((currentState) => {
                const diff = currentState === null || currentState === void 0 ? void 0 : currentState.filter((selectedEntry) => selectedEntry.id !== entry.id);
                if (diff.length === currentState.length) {
                    return [...currentState, entry];
                }
                return diff;
            });
        }
    }, [multiselect, setEntries]);
    const handleSubmit = () => {
        if (multiselect === true) {
            onSubmit(entries);
        }
        else {
            const [singleEntry] = entries;
            if (!singleEntry) {
                return;
            }
            onSubmit(singleEntry);
        }
    };
    const selectableDefault = (entry) => entry.kind === EntryKind.Document;
    const fileBrowserProviderProps = {
        customLoadingState: true,
        showSignRequestStatus: true,
        parentId: initialFolderId,
        selected: entries,
        onSelect: handleSelectEntry,
        selectable: selectable || selectableDefault,
        includeDocumentAi,
        selfId,
        controlledLoading: loading,
    };
    return (<FileBrowserProvider {...fileBrowserProviderProps}>
      <FileDialog {...props} onSubmit={handleSubmit} multiselect={multiselect}/>
    </FileBrowserProvider>);
}
